module.exports = __webpack_public_path__ + "static/media/2.935da0e7.svg";